/**
 * Represents Pharmacy Data
 */

 export interface PharmacyData {
    /**
     * Pharmacy Name
     */
    pharmacyname: string;
    /**
     * Pharmacy Number
     */
    pharmacynumber:string;
    /**
     * Pharmacy Address
     */
    pharmacyaddress: string;
}
